// When DOM is loaded
$(function () {
    $(window).on("scroll", function (event) {
        var result = $(document).scrollTop();
        //console.log(result);
        //when position is x, manipulate element

        if (result > 300) {
            $("nav.navbar").addClass("navbar-small");
        } else {
            $("nav.navbar").removeClass("navbar-small");
           }
        //$("#check-me-out").text(result);
    });
});